/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import {
	GENERIC_USER_ERROR,
	NOT_AUTHORIZED_FOR_QUERY_ERROR_CODE,
	USER_AUTHORITY_ERROR_KEY,
} from '@/data/constants/errors';
import { TransactionErrorResponse } from '@/data/types/Basic';
import { extractResponseError } from '@/data/utils/extractResponseError';

export const isNotAuthorizedError = (error: unknown): boolean => {
	const responseError = extractResponseError(error as TransactionErrorResponse);
	return (
		responseError?.errorCode === NOT_AUTHORIZED_FOR_QUERY_ERROR_CODE ||
		responseError?.errorKey === GENERIC_USER_ERROR ||
		responseError?.errorKey === USER_AUTHORITY_ERROR_KEY
	);
};
